/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import { ApplicationConfigurationResponseDataResponse, ErrorResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class ApplicationConfigurations<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags ApplicationConfigurations
   * @name ApplicationConfigurationsList
   * @request GET:/ApplicationConfigurations
   * @response `200` `ApplicationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  applicationConfigurationsList = (params: RequestParams = {}) =>
    this.http.request<ApplicationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/ApplicationConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
